import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "audit",
  "use": "audit-usage",
  "viewBox": "0 0 14 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 17\" id=\"audit\"><path d=\"M.037 0L0 16.027h13.01V2.051h-1.994V0H.037zM1.04 14.023h9.959V3.016H12v11.963H1.04v-.956zm6.483-9.042l.992.991-3.688 3.699-2.284-2.285.991-.992 1.293 1.292 2.696-2.705z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id